import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Plus, Edit2, Trash2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

const AdminProducts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/products").then((r) => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    try {
      await api.delete(`/admin/products/${id}`);
      toast.success("Deleted");
      load();
    } catch (e) {
      toast.error("Failed to delete");
    }
  };

  return (
    <div data-testid="admin-products">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-black tracking-tight text-zinc-950">Products</h1>
          <p className="text-sm text-zinc-500 mt-1">{items.length} total</p>
        </div>
        <Link to="/admin/products/new" data-testid="admin-product-new" className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-md inline-flex items-center gap-2 transition-colors">
          <Plus size={16} /> New product
        </Link>
      </div>

      <div className="mt-8 bg-white border border-zinc-200 rounded-md">
        {loading ? (
          <div className="p-10 text-center text-zinc-500 text-sm">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">No products yet.</div>
        ) : (
          <div className="divide-y divide-zinc-100">
            {items.map((p) => (
              <div key={p.id} className="px-6 py-4 flex items-center justify-between gap-4" data-testid={`admin-product-row-${p.slug}`}>
                <div>
                  <div className="font-semibold text-zinc-900 flex items-center gap-2">
                    {p.name}
                    {p.is_published ? (
                      <span className="text-xs text-green-700 bg-green-50 px-2 py-0.5 rounded-full inline-flex items-center gap-1"><Eye size={12} /> Published</span>
                    ) : (
                      <span className="text-xs text-zinc-600 bg-zinc-100 px-2 py-0.5 rounded-full inline-flex items-center gap-1"><EyeOff size={12} /> Draft</span>
                    )}
                  </div>
                  <div className="text-xs text-zinc-500 mt-1">/{p.slug} · {p.category}</div>
                </div>
                <div className="flex items-center gap-2">
                  <Link to={`/admin/products/${p.id}`} data-testid={`admin-product-edit-${p.slug}`} className="p-2 rounded-md hover:bg-zinc-100 text-zinc-600"><Edit2 size={16} /></Link>
                  <button onClick={() => remove(p.id)} data-testid={`admin-product-delete-${p.slug}`} className="p-2 rounded-md hover:bg-red-50 text-red-600"><Trash2 size={16} /></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminProducts;
